import React from "react";
import { Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { HIDE_ROUTE_DETAILS_MULTISTART_CARD, SEE_ROUTE_DETAILS_MULTISTART_CARD } from "../UserVisibleStrings";

type SeeRouteDetailsButtonProps = {
    open: boolean,
    onClick: ( e: React.MouseEvent<HTMLButtonElement> ) => void,
};

export default function SeeRouteDetailsButton( { open, onClick }: SeeRouteDetailsButtonProps )
{
    return (
        <Button
            onClick = {onClick}
            sx = {{
                textTransform: "none",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
            }}
        >
            {open ? HIDE_ROUTE_DETAILS_MULTISTART_CARD : SEE_ROUTE_DETAILS_MULTISTART_CARD}

            <ExpandMoreIcon
                sx = {{
                    transition: "transform 0.3s ease",
                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                    fontSize: "20px",
                }}
            />
        </Button>
    );
}
